import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { corporateCMSApi, post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { fields } from "../constants";
import { useLinks } from "../Milestones.hooks";

export const AddEditLinks = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [records, setRecords] = useState<any[]>([]);
  const [parentList, setParentList] = useState<any[]>([]);

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useLinks(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const getParentRecords = () => {
    let url = `/api/airport-academy-achievement`;
    corporateCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setParentList(envelopes);
        }
      })
      .catch((err) => {
        setRecords([]);
      });
  };

  const getIdByName = (title: string) => {
    if (!parentList || parentList.length === 0) return null;

    const item = parentList.find((entry) => entry.title?.trim().toLowerCase() === title?.trim().toLowerCase());

    return item ? item.id : null;
  };

  useEffect(() => {
    getParentRecords();
  }, []);

  const milestoneLinkConfig: FormConfig = {
    initialValues: {
      field_achievement_order_sequence: dataById
        ? decodeHTML(dataById?.payload?.field_achievement_order_sequence)
        : editData
          ? decodeHTML(editData?.field_achievement_order_sequence)
          : "",
      id: dataById ? dataById.payload.id : editData ? editData?.id : "",
      field_text: dataById ? decodeHTML(dataById.payload.field_text) : editData ? decodeHTML(editData?.field_text) : "",
      field_link: dataById ? decodeHTML(dataById.payload.field_link) : editData ? decodeHTML(editData?.field_link) : "",
      parent_id: dataById ? decodeHTML(dataById.payload.parent_id) : editData ? decodeHTML(editData?.parent_id) : "",
      parent_title: dataById
        ? decodeHTML(dataById.payload.parent_title)
        : editData
          ? decodeHTML(editData?.parent_title)
          : "",

      published: dataById
        ? dataById.payload.published === "true" || dataById.payload.published === true
        : editData
          ? editData.published === "true"
          : false,
    },
    fields: fields.milestoneLinks,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_news_images"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let dateKeys: any = ["date"];
    for (const key of dateKeys) {
      if (data[key]) {
        data[key] = moment(data[key]).format("DD MMM YYYY");
      }
    }

    if (data.parent_title) {
      const parentId = getIdByName(data.parent_title);
      console.log(parentId, data.parent_title, "abcdef");
      if (parentId) {
        data.parent_id = parentId;
      }
    }

    console.log(data, "parentId");
    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "milestones_milestoneLinks",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_Milestones",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        order_sequence: Number(data?.order_sequence),
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add"} Links`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={milestoneLinkConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${corporateHost}/api/airport-academy-achievement-paragraph/${editData?.id || dataById?.payload?.id}` : `${corporateHost}/api/airport-academy-achievement-paragraph`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Malaysia Airports Academy"
      />
    </ContentWrapper>
  );
};
